/* tj-fx.js — transición entre páginas y revelado al hacer scroll (TUS JERSEYS) */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && Shopify.designMode;

  /* ---------- Cortina al salir de la página ---------- */
  window.addEventListener('pageshow', function () { html.classList.remove('tj-leaving'); });
  function go(url) {
    location.href = url; return;
    html.classList.add('tj-leaving');
    setTimeout(function () { location.href = url; }, 430);
  }
  window.TJ_go = go;
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-act') || a.hasAttribute('download')) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return; // mismo documento (anclas)
    e.preventDefault();
    go(u.href);
  });

  /* ---------- Revelado al hacer scroll ---------- */
  var SEL = [
    '.tj-top__h', '.tj-top__d', '.tj-chips', '.tj-may__head', '.tj-ladder', '.tj-extras', '.tj-may__n', '.tj-card',
    '.tj-cotiza h2', '.tj-cotiza p', '.tj-cotiza__b', '.tj-foot__g > div', '.tj-foot__legal',
    '.tj-h2c', '.tj-lead', '.tj-pkg', '.tj-h2l', '.tj-sub14', '.tj-pq__c', '.tj-acc__i', '.tj-rv__head',
    '.tj-galcol', '.tj-buy > .tj-title', '.tj-buy > .tj-sold', '.tj-buy > .tj-pricerow', '.tj-buy > .tj-pills', '.tj-buy > .tj-msi',
    '.tj-buy > .tj-sec', '.tj-buy > .tj-models', '.tj-buy > .tj-matrix', '.tj-cm__in',
    '.tj-stat', '.tj-pasos .tj-eyebrow', '.tj-pasos .tj-bigh', '.tj-paso', '.tj-top .tj-eyebrow', '.tj-calc2__in', '.tj-faq__l', '.tj-q'
  ].join(',');
  function setup() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    var els = [].slice.call(d.querySelectorAll(SEL));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var counts = new Map();
    els.forEach(function (el) {
      var p = el.parentNode, i = counts.get(p) || 0; counts.set(p, i + 1);
      var inView = el.getBoundingClientRect().top < innerHeight;
      el.style.setProperty('--tj-d', (Math.min(i, 6) * 0.03) + 's');
      el.classList.add('tj-reveal');
      io.observe(el);
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', setup); else setup();
})();
